import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem('sessionToken');
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;

  const hasVoted = user && user.votes >= 1;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasVoted) {
    return <Navigate to="/vote" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;